module.exports = __webpack_public_path__ + "static/media/shequ-title-1.1e6cf4da.png";